// skipcq: JS-W1028, JS-0128
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import ArrowBack from '@mui/icons-material/ArrowBack';

/**
 * BreweryBackButton
 * Simple back button used in the Brewery details layout.
 */
function BreweryBackButton({ handleBackNavigation, label }) {
  return (
    <Button onClick={handleBackNavigation} style={{ margin: '5px' }}>
      <ArrowBack />
      {label}
    </Button>
  );
}

BreweryBackButton.propTypes = {
  handleBackNavigation: PropTypes.func.isRequired,
  label: PropTypes.string,
};

BreweryBackButton.defaultProps = {
  label: 'Back to List',
};

export default BreweryBackButton;


